type TeamMapping = {
  teamNameExternal: string;
  teamNamePortal: string;
};

export function createDatadogUrl(teams: TeamMapping[]): string {
  const urlParams = teams
    .map(({ teamNameExternal, teamNamePortal }, index) => {
      return (
        `&tpl_var_team%5B${index}%5D=${encodeURIComponent(teamNamePortal)}` +
        `&tpl_var_ddTeam%5B${index}%5D=${encodeURIComponent(teamNameExternal)}`
      );
    })
    .join('');

  return `https://app.datadoghq.eu/dashboard/ir4-ai8-w9b/scalar-team-cost-dashboard?fromUser=false&refresh_mode=sliding${urlParams}`;
}
